import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InvoicesResolver } from './resolvers/invoices.resolver';
import { InvoiceResolver } from './resolvers/invoice.resolver';
import { InvoiceLineResolver } from './resolvers/invoice-line.resolver';
import { WeekInvoicesResolver } from './resolvers/week-invoices.resolver';
import { InvoicesComponent } from './invoices.component';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { InvoiceLineDetailComponent } from './invoice-detail/invoice-line/invoice-line-detail.component';
import { InvoiceSettingsComponent } from './invoice-settings.component';
import { InvoiceCreateComponent } from './invoice-create/invoice-create.component';
import { OrganisationResolver } from '../resolvers/organisation.resolver';
import { CustomersResolver } from './resolvers/customers.resolver';
import {InvoicesCountResolver} from './resolvers/invoices-count.resolver';

const invoiceRoutes: Routes = [
	{
		path: '', data: {breadcrumb: 'Facturen'},
		children: [
			{
				path: 'instellingen',
				data: {title: 'Instellingen facturatie', breadcrumb: 'Instellingen Facturatie'},
				component: InvoiceSettingsComponent,
				resolve: {organisation: OrganisationResolver}
			},
			{
				path: 'aanmaken',
				data: {title: 'Factuur aanmaken', breadcrumb: 'Factuur Aanmaken'},
				component: InvoiceCreateComponent,
				resolve: { organisation: OrganisationResolver, customers: CustomersResolver }
			},
			{
				path: ':id', data: {breadcrumb: 'Factuur Detail'}, resolve: {invoice: InvoiceResolver},
				children: [
					{
						path: 'regel/:lineId',
						data: {title: 'Factuurregel wijzigen', breadcrumb: 'Factuurregel Wijzigen'},
						component: InvoiceLineDetailComponent,
						resolve: {invoiceLine: InvoiceLineResolver}
					},
					{
						path: '', data: {title: 'Factuur detail'}, component: InvoiceDetailComponent,
					}
				]
			},
			{
				path: '', data: {title: 'Facturen'}, component: InvoicesComponent,
				resolve: {weekInvoices: WeekInvoicesResolver, invoices_count: InvoicesCountResolver}
			}
		]
	},
];

@NgModule({
	imports: [RouterModule.forChild(invoiceRoutes)],
	exports: [RouterModule],
	providers: [InvoicesResolver, InvoiceResolver, InvoiceLineResolver, InvoicesCountResolver, WeekInvoicesResolver, OrganisationResolver, CustomersResolver]
})

export class InvoicesRoutingModule
{
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoices-routing.module.ts